import { BenefitsTooltipContent } from "./BenefitsTooltipContent.js";
import { BenefitsTooltipTitle } from "./BenefitsTooltipTitle.js";
const BenefitsTooltip = { Title: BenefitsTooltipTitle, Content: BenefitsTooltipContent };
export {
  BenefitsTooltip
};
